"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppManagerService = void 0;
const core_1 = require("@angular/core");
const rxjs_1 = require("rxjs");
let AppManagerService = class AppManagerService {
    constructor() {
        this.openAppSource = new rxjs_1.Subject();
        this.openAppRequest$ = this.openAppSource.asObservable();
        this.navigateToSectionSource = new rxjs_1.Subject();
        this.navigateToSection$ = this.navigateToSectionSource.asObservable();
    }
    openApp(appId, section) {
        this.openAppSource.next(appId);
        if (section) {
            this.navigateToSectionSource.next(section);
        }
    }
};
exports.AppManagerService = AppManagerService;
exports.AppManagerService = AppManagerService = __decorate([
    (0, core_1.Injectable)({ providedIn: 'root' })
], AppManagerService);
